import React from 'react';
import SvgIcon from './SvgIcon';

const UKGLogo = props => (
    <SvgIcon viewBox="0 0 150 150" aria-label="UKG" {...props}>
        <path d="M0 0h150v150H0Z" fill="#035051" />
        <path
            d="M46.19 27.76A14.37 14.37 0 1 1 31.83 13.4a14.37 14.37 0 0 1 14.36 14.36m87.68 0a14.32 14.32 0 1 1-14.26-14.36 14.38 14.38 0 0 1 14.26 14.36"
            fill="#32cfbb"
        />
        <path
            d="M75.66 134.48A57.49 57.49 0 0 1 18.21 77v-9.12a13.51 13.51 0 1 1 27 0v9.47c0 16.7 9.9 30.32 30.33 30.32 19 0 30.32-13.62 30.32-30.32v-9.47a13.52 13.52 0 1 1 27 0V77a57.18 57.18 0 0 1-57.25 57.45"
            fill="#ffffff"
        />
    </SvgIcon>
);

UKGLogo.displayName = 'UKGLogoIcon';

export default UKGLogo;
